'use client';

import React, { Suspense, lazy, type ReactNode } from 'react';

import { Spinner } from '@chakra-ui/spinner';
import type { ChatActions } from './Context';

const ClientOnlyChatProvider = lazy(async () => import('./ClientOnlyChatProvider'));

// This component provides the trpc client for the support chat service.
export function ChatProvider({
  chatActions,
  children,
  fallback,
}: {
  chatActions: ChatActions;
  children?: React.ReactNode;
  fallback?: ReactNode;
}) {
  return (
    <Suspense fallback={fallback ?? <Spinner />}>
      <ClientOnlyChatProvider chatActions={chatActions} fallback={fallback}>
        {children}
      </ClientOnlyChatProvider>
    </Suspense>
  );
}

export default ChatProvider;
